import { useEffect, useRef, useState } from "hono/jsx";
import { asset } from "../../common/manifest.ts";

export const LatencyMap = ({ js }: { js: string }) => {
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!mapContainerRef.current) return;

    let cleanup: (() => void) | undefined;
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds

    const init = () => {
      // @ts-ignore: global definition
      const global = globalThis as any;
      if (global.initLatencyMap && mapContainerRef.current) {
        const ctrl = global.initLatencyMap(mapContainerRef.current);
        cleanup = ctrl.destroy;
        setIsLoaded(true);
        return true;
      }
      return false;
    };

    if (init()) return;

    const interval = setInterval(() => {
      attempts++;
      if (init()) {
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn("Failed to load LatencyMap script");
      }
    }, 100);

    return () => {
      clearInterval(interval);
      if (cleanup) cleanup();
    };
  }, []);

  return (
    <div class="relative w-full aspect-video rounded-lg overflow-hidden border border-base-content/10 bg-base-200">
      <div ref={mapContainerRef} class="w-full h-full z-0" />

      {/* Overlay Legend */}
      <div class="absolute bottom-2 right-2 z-50 flex flex-col gap-1 text-[10px] font-mono opacity-80 bg-base-100/90 p-2 rounded shadow-sm">
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-success"></div>
          <span>~40ms (Fiber)</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full bg-warning"></div>
          <span>~140ms (Trans-Atlantic)</span>
        </div>
      </div>

      {/* Loading State if script delays */}
      {!isLoaded && (
        <div class="absolute inset-0 flex items-center justify-center bg-base-200 z-10 pointer-events-none">
          <span class="loading loading-spinner loading-sm opacity-50"></span>
        </div>
      )}
    </div>
  );
};
